var tooltipData = {
  name: 'tooltip',
  data: [{
    backgroundColor: 'rgba(0,0,0,0.75)'
  }]
};
export default tooltipData;